module.exports = __webpack_public_path__ + "static/media/about-kovel-poster-2.9c82594d.png";